import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import {
  Document,
  SupportingDocumentCreate,
} from '@lockton-apps/shared/interfaces';
import { toFormData } from '@lockton-apps/shared/util/helpers';

@Injectable({
  providedIn: 'root',
})
export class SupportingDocumentsService {
  model = 'supporting-document';

  constructor(
    private http: HttpClient,
    @Inject('BASE_API_URL') private baseUrl: string,
    @Inject('AZURE_STORAGE_ACCOUNT_NAME') private storageAccountName: string
  ) {}

  add(model: SupportingDocumentCreate) {
    const formData = toFormData({
      ...model,
      storageAccountName: this.storageAccountName,
    });
    return this.http.post<Document>(this._getUrl(), formData);
  }

  private _getUrl() {
    return `${this.baseUrl}/${this.model}`;
  }
}
